import { Component, OnInit, SimpleChanges, ViewChild } from "@angular/core";
import { Router, ActivatedRoute, NavigationEnd } from "@angular/router";
import {
  FormArray,
  FormGroup,
  FormControl,
  FormBuilder,
  Validators,
} from "@angular/forms";
import { ToastService } from "ng-uikit-pro-standard";
import { DataService } from "src/app/data.service";
import { ObjectselectComponent } from "src/app/matchingrule/objectselect/objectselect.component";
import { AppConfig } from "src/app/config";
import { GUID } from "src/app/guid";
@Component({
  selector: "app-duplicaterulenew",
  templateUrl: "./duplicaterulenew.component.html",
  styleUrls: ["./duplicaterulenew.component.scss"],
})
export class DuplicaterulenewComponent implements OnInit {
  @ViewChild(ObjectselectComponent, { static: false })
  objectSelectComponent: ObjectselectComponent;

  guid: GUID;
  ruleobjectname = "";
  metaobjectId = "";
  objectName = "";
  duplicateRuleId = "";
  matchingRuleId = "";
  matchingRuleName = "";
  currentTemplate = "objectSelect";
  mode = "";
  isLoading = false;
  isError = false;
  errorMessage = "";
  isDataLoaded = false;

  detailForm = this.fb.group({
    object: new FormControl({ value: "", disabled: true }, Validators.required),
    rulename: "",
    uniquename: "",
    description: "",
    recordlevelsecurity: ["enforce sharing rules"],
  });

  actionForm = this.fb.group({
    actiononcreate: "",
    actiononcreatealert: false,
    actiononcreatereport: false,
    actiononedit: "",
    actiononeditalert: false,
    actiononeditreport: false,
    alerttext: "",
  });

  matchingRuleForm: FormGroup;
  filterForm: FormGroup;
  filteritems: FormArray;

  // matchingRuleForm = this.fb.group({
  //   objectid: "",
  //   objectname: "",
  //   object: "",
  //   matchingruleid: "",
  //   matchingrulename: "",
  //   matchingrule: "",
  // });
  parentObjects: any[];
  duplicateRules: any;
  matchingRules: any[];
  fields = [];
  fieldList = [];
  picklistValueList = [];
  checkboxValueList = [
    { label: "True", value: true },
    { label: "False", value: false },
  ];
  operatorList = [];
  allFields: any;
  combinedallFields: any;
  metaobjectList: any;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private toastrService: ToastService,
    private dataService: DataService,
    private appConfig: AppConfig
  ) {}
  ngOnInit() {
    this.guid = new GUID();
    this.matchingRuleForm = this.fb.group({
      rules: this.fb.array([this.createRule()]), // Initialize with one form group
    });
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        // Refresh the page on URL change
        window.location.reload();
      }
    });
    this.route.queryParams.subscribe((params) => {
      // this.mode = this.route.snapshot.params.mode;
      this.currentTemplate = this.route.snapshot.params.template;
      this.mode = this.route.snapshot.params.mode;

      this.objectName = this.route.snapshot.params.objectname;
      this.metaobjectId = this.route.snapshot.params.objectid;
      this.duplicateRuleId = this.route.snapshot.params.id;
    });

    this.detailForm.controls["object"].setValue(this.objectName);

    this.getActiveObjectsByType().then((res) => {
      if (this.mode.toLocaleLowerCase() == "new") {
        this.isLoading = false;
      }
    });

    this.filterForm = this.fb.group({
      filteritems: this.fb.array([]),
      filterlogic: "1",
      active: true,
    });

    //create operator type picklist from operatortypes
    for (let i = 0; i < this.appConfig.operatorTypes.length; i++) {
      //convert to titecase
      var strLabel = this.appConfig.operatorTypes[i];
      strLabel = strLabel[0].toUpperCase() + strLabel.slice(1);
      this.operatorList.push({
        value: this.appConfig.operatorTypes[i],
        label: strLabel,
      });
    }

    if (this.mode.toLocaleLowerCase().trim() == "new") {
      if (this.currentTemplate.toLocaleLowerCase() == "create") {
        this.getMetaFieldsForSelection().then((res) => {
          console.log("response1111", res);
          // this.fields = res
          console.log("Field list after processing:", this.fields);

          this.retrieveLookupFields().then((res) => {
            console.log("response1111", res);
            // console.log("Field list after processing:", this.allFields);
            console.log("Field list after processing:", this.fields);

            // const fieldsForSelection = [...this.fields, ...this.allFields];
            const fieldsForSelection = [...this.fields, ...this.allFields];

            //add default --None-- into field list
            this.fieldList.push({
              value: "--None--",
              label: "--None--",
              fieldtype: "text",
              standard: true,
              options: [],
              id: "",
            });

            console.log(fieldsForSelection);

            //create fieldlist from fields as readable form by selection control
            for (let i = 0; i < fieldsForSelection.length; i++) {
              var field = fieldsForSelection[i];

              console.log(field.labelname);

              //skip id type fields if there
              if (field.fieldtype.toLowerCase() == "id") continue;

              //skip fields with visibility false
              if (field.visible == false) continue;

              //skip fields deleted, ownertype etc.,
              if (
                field.fieldname.toLowerCase() == "deleted" ||
                field.fieldname.toLowerCase() == "ownertype" ||
                field.fieldname.toLowerCase() == "migrated" ||
                field.fieldname.toLowerCase() == "organizationid" ||
                field.fieldname.toLowerCase() == "search" ||
                field.fieldname.toLowerCase() == "date_range"
              )
                continue;

              //skip converted field if object is lead
              if (
                this.objectName.toLowerCase().trim() == "lead" &&
                field.fieldname.toLowerCase() == "converted"
              )
                continue;

              //convert to titecase
              var strLabel = field.labelname;
              var formattedLabel = field.metaobjectname + ": " + strLabel;

              strLabel = strLabel[0].toUpperCase() + strLabel.slice(1);
              this.fieldList.push({
                // value: field.fieldname,
                value: field.id,

                label: formattedLabel,
                fieldtype: field.fieldtype,
                standard: field.standard,
                options: field.options,
                metaobjectname: field.metaobjectname,

                // id: field.id,
                id: field.fieldname,
              });
            }

            //load default done list first
            // this.loadDefaultDoneList();

            this.addFilterItem("", "", "", [], "", "", "", "");
            this.addFilterItem("", "", "", [], "", "", "", "");
            this.addFilterItem("", "", "", [], "", "", "", "");

            // this.isDataLoaded = true;
          });
          this.isLoading = false;
          this.isDataLoaded = true;
        });
      }
      // this.retrieveLookupFields().then(() => {
      //   setTimeout(() => {
      //     this.getMetaFieldsForSelection().then((res) => {
      //       console.log("response1111", res);

      //       console.log("lookupFieldsRes", this.allFields);
      //       console.log(this.fields);
      //       // this.fields = [...this.fields, ...this.allFields];
      //       // console.log(this.fields);
      //       // Load default done list first

      //       if (this.allFields) {
      //         this.allFields.forEach((field) => {
      //           this.fieldList.push(field);
      //           // this.secondfieldsToDo.push(field);
      //         });
      //         this.isDataLoaded = true;
      //       }
      //       // This retrieveMetabuttons function call seems related to buttons, not fields
      //       // this.retrieveMetabuttons().then((res) => {
      //       //   this.loadDefaultButtonDoneList();
      //       //   this.loadsecondDefaultButtonDoneList();
      //       // });

      //       this.addFilterItem("", "", "", [], "", "");
      //       this.addFilterItem("", "", "", [], "", "");
      //       this.addFilterItem("", "", "", [], "", "");

      //       this.isDataLoaded = true;

      //       // Retrieve lookup fields after loading meta fields
      //       // this.retrieveLookupFields().then(() => {
      //       //   console.log("lookupFieldsRes", this.allFields);

      //       //   // Combine the fields from both sources
      //       //   // this.fields = [...this.fields, ...allFields];

      //       //   console.log("All fields combined", this.fields);
      //       // });

      //       // this.loadDefaultDoneList();
      //       // this.loadSecondDefaultDoneList();
      //     });
      //   }, 1000);
      // });
    } else {
      //load queues
      this.retrieveLookupFields().then((res) => {
        console.log("response1111", res);

        this.getMetaFieldsForSelection().then((res) => {
          console.log("response1111", res);
          // load metalayout details

          const fieldsForSelection = [...this.fields, ...this.allFields];

          this.getDuplicateRuleById(fieldsForSelection).then(() => {
            // console.log("this.metalayout", this.metalayout);
            // console.log("this.res", res);
            console.log(this.allFields);

            // this.combinedallFields = [...this.fields, ...this.allFields];

            // this.allFields.forEach((field) => {
            //   // this.firstfieldsToDo.push(field);
            //   this.secondfieldsToDo.push(field);
            // });

            //assign metalayout detail data
            // this.assignMetalayoutData();

            // if (this.filteritems == null) {
            //   this.addFilterItem("", "", "", "", "", "");
            //   this.addFilterItem("", "", "", "", "", "");
            //   this.addFilterItem("", "", "", "", "", "");
            // } else if (this.filteritems.length == 1) {
            //   this.addFilterItem("", "", "", "", "", "");
            //   this.addFilterItem("", "", "", "", "", "");
            // } else if (this.filteritems.length == 2) {
            //   this.addFilterItem("", "", "", "", "", "");
            // }

            // this.isDataLoaded = true;

            // this.retrieveLookupFields();
          });
        }); //getMetaLayoutByName()
      });
    }
  }

  // Function to create a single form group (one rule)
  createRule(): FormGroup {
    return this.fb.group({
      object: ["", Validators.required],
      matchingrule: ["", Validators.required],
      objectname: "",
      objectid: "",
      matchingruleid: "",
      matchingrulename: "",
    });
  }

  // Function to get the form array
  get rules(): FormArray {
    return this.matchingRuleForm.get("rules") as FormArray;
  }

  // Add another rule (max 2)
  // addRule(): void {
  //   if (this.rules.length < 3) {
  //     this.rules.push(this.createRule());
  //   }
  // }
  addRule() {
    const rulesArray = this.matchingRuleForm.get("rules") as FormArray;
    rulesArray.push(this.createRule()); // Add a new form group to the array
  }

  showSuccess(data: any) {
    let options = {
      enableHtml: true,
      positionClass: "md-toast-top-right",
      timeOut: 3000,
    };
    this.toastrService.success(data, "", options);
  }

  showError(data: any) {
    let options = { enableHtml: true, positionClass: "md-toast-bottom-right" };
    this.toastrService.error(data, "Metaobject Error!", options);
  }

  showWarning(data: any) {
    let options = {
      enableHtml: true,
      positionClass: "md-toast-bottom-right",
      messageClass: "orange darken-4",
      toastClass: "warning-color-dark",
    };
    this.toastrService.warning(data, "", options);
  }

  fieldSelected(
    event: { id: any; fieldtype: any; options: string; metaobjectname: string },
    index: number
  ) {
    console.log("fieldSelected");
    console.log("index", index);
    console.log("event", event);

    var i = 0;
    var arrayControl = this.filterForm.get("filteritems") as FormArray;
    for (let c of arrayControl.controls) {
      console.log(c);
      if (i == index) {
        console.log("matching", c);
        c.get("fieldid").setValue(event.id);
        c.get("fieldtype").setValue(event.fieldtype);
        c.get("options").setValue(event.options);
        c.get("metaobjectname").setValue(event.metaobjectname);

        if (c.get("operator").value == "") {
          c.get("operator").setValue("equals"); //default operator set
        }
        if (event.options != "") {
          var arr = JSON.parse(event.options);
          this.picklistValueList[index] = arr;
          c.get("operator").setValue("equals"); //default operator set
        }
        c.get("fieldvalue").setValue("");
        break;
      }
      i++;
    }
  }

  addFilter(index: any) {
    if (this.filteritems != null && this.filteritems.length < 10) {
      this.addFilterItem("", "", "", "", "", "", "", "");
    }
  }

  removeFilter(index: any) {
    this.removeFilterItem(index);
  }

  createItem(
    id: any,
    name: any,
    ftype: any,
    opt: any,
    opr: any,
    vl: any,
    flogic: string,
    objName: string
  ): FormGroup {
    return this.fb.group({
      //fieldlist: fldlist,
      //operatorlist: oplist,
      fieldid: id,
      fieldname: name,
      fieldtype: ftype,
      options: opt,
      operator: opr,
      fieldvalue: vl,
      filterlogic: flogic,
      metaobjectname: objName,
    });
  }

  addFilterItem(
    id: string,
    name: string,
    ftype: string,
    opt: string | any[],
    opr: string,
    vl: string,
    flogic = "AND",
    objname: string
  ): void {
    this.filteritems = this.filterForm.get("filteritems") as FormArray;
    this.filteritems.push(
      this.createItem(name, id, ftype, opt, opr, vl, flogic, objname)
    );
    this.picklistValueList.push([]);
  }

  removeFilterItem(index: number) {
    if (index > 0) {
      this.filteritems.removeAt(index);
    }
  }

  getMetaFieldsForSelection() {
    return new Promise((resolve, reject) => {
      console.log("getMetaFieldsForSelection");

      var userDetail = JSON.parse(localStorage.getItem("crm_userdetails"));

      let postOption = {
        organizationid: localStorage.getItem("crm_orgid"),
        userid: localStorage.getItem("crm_userid"),
        username: localStorage.getItem("crm_username"),
        // domain: localStorage.getItem("domain"),
        // subdomain: localStorage.getItem("subdomain"),
        domain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.domain`
        ),
        subdomain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.subdomain`
        ),
        profileid: userDetail.profileid,
        data: {
          metafield: {
            metaobjectid: this.metaobjectId,
            metaobjectname: this.objectName,
          },
        },
      };

      console.log("postOption", postOption);

      // this.isLoading = true;
      this.dataService.getMetaFieldsForSelection(postOption).subscribe(
        (res) => {
          console.log(res);
          if (res !== null && res.success == 1) {
            this.fields = res.data.metafields;

            // //add default --None-- into field list
            // this.fieldList.push({
            //   value: "--None--",
            //   label: "--None--",
            //   fieldtype: "text",
            //   standard: true,
            //   options: [],
            //   id: "",
            // });

            // Check if "--None--" is already present in the list
            if (!this.fieldList.some((item) => item.value === "--None--")) {
              this.fieldList.push({
                value: "--None--",
                label: "--None--",
                fieldtype: "text",
                standard: true,
                options: [],
                id: "",
              });
            }

            // //create fieldlist from fields as readable form by selection control
            // for (let i = 0; i < this.fields.length; i++) {
            //   var field = this.fields[i];

            //   //skip id type fields if there
            //   if (field.fieldtype.toLowerCase() == "id") continue;

            //   //skip fields with visibility false
            //   if (field.visible == false) continue;

            //   //skip fields deleted, ownertype etc.,
            //   if (
            //     field.fieldname.toLowerCase() == "deleted" ||
            //     field.fieldname.toLowerCase() == "ownertype" ||
            //     field.fieldname.toLowerCase() == "migrated" ||
            //     field.fieldname.toLowerCase() == "organizationid" ||
            //     field.fieldname.toLowerCase() == "search" ||
            //     field.fieldname.toLowerCase() == "date_range"
            //   )
            //     continue;

            //   //skip converted field if object is lead
            //   if (
            //     this.objectName.toLowerCase().trim() == "lead" &&
            //     field.fieldname.toLowerCase() == "converted"
            //   )
            //     continue;

            //   //convert to titecase
            //   var strLabel = field.labelname;

            //   var formattedLabel = field.metaobjectname + ': ' + strLabel;

            //   strLabel = strLabel[0].toUpperCase() + strLabel.slice(1);
            //   this.fieldList.push({
            //     value: field.fieldname,
            //     label: formattedLabel,
            //     fieldtype: field.fieldtype,
            //     standard: field.standard,
            //     options: field.options,
            //     metaobjectname:field.metaobjectname,
            //     id: field.id,
            //   });
            // }

            // this.isDataLoaded = true;

            resolve(this.fields);
          } else {
            console.log("No fields data!");
            this.isLoading = false;
            resolve(null);
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          resolve(null);
        }
      );
    });
  }

  retrieveLookupFields() {
    return new Promise((resolve, reject) => {
      console.log("LookupFields");

      let postOption = {
        organizationid: localStorage.getItem("crm_orgid"),
        userid: localStorage.getItem("crm_userid"),
        username: localStorage.getItem("crm_username"),
        // domain: localStorage.getItem("domain"),
        // subdomain: localStorage.getItem("subdomain"),
        domain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.domain`
        ),
        subdomain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.subdomain`
        ),
        data: {
          metafield: {
            metaobjectid: this.metaobjectId,
            metaobjectname: this.objectName,
            fieldtype: "lookup",
          },
        },
      };
      console.log("postOption", postOption);
      // this.isLoading = true;
      this.dataService.getObjectLookupFields(postOption).subscribe(
        (res) => {
          console.log("res", res);

          if (res !== null && res.success == 1) {
            this.metaobjectList = res.metaobject;
            console.log(this.metaobjectList);
            if (this.metaobjectList) {
              // Loop through the metaobjectList and call getMetaFieldsForSelection
              const promises = this.metaobjectList.map((metaobject) => {
                return this.getObjectLookupFieldsForFieldsList(
                  metaobject.relatedobjectid,
                  metaobject.relatedto,
                  metaobject.metafieldname
                );
              });

              Promise.all(promises)
                .then((results) => {
                  console.log("Promise.all results:", results);

                  // const allFields = [];

                  // Iterate through each result (fields array) and concatenate into allFields
                  // results.forEach((fields) => {
                  //   if (fields && Array.isArray(fields)) {
                  //     allFields.push(...fields);
                  //   }
                  //   return allFields
                  // });
                  // const allFields = results.reduce((acc, fields) => {
                  //   if (fields && Array.isArray(fields)) {
                  //     acc.push(...fields);
                  //   }
                  //   return acc;
                  // }, []);
                  const allFields = results.reduce((acc: any[], fields) => {
                    if (fields && Array.isArray(fields)) {
                      acc.push(...fields);
                    }
                    return acc;
                  }, []);

                  this.allFields = allFields;

                  console.log("Combined lookup fields", this.allFields);

                  // this.isLoading = false;
                  resolve(this.allFields); // Resolve with the combined fields
                })
                .catch((err) => {
                  console.log("Error***:", err);
                  this.errorMessage = err.message;
                  this.isError = true;
                  this.isLoading = false;
                  resolve(null);
                });
            }

            // this.isLoading = false;
            // resolve(this.allFields);
          } else {
            console.log("No  metaobject data!");
            this.errorMessage =
              res != null ? res.message : "No  metaobject data!";
            this.isError = true;
            this.isLoading = false;
            resolve(null);
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          resolve(null);
          // this.metalayoutbutton.push(button);
        }
      );
    });
  }

  getObjectLookupFieldsForFieldsList(
    metaobjectid: any,
    metaobjectname: any,
    metafieldname: any
  ) {
    return new Promise((resolve, reject) => {
      console.log("getMetaFieldsForSelection");

      var userDetail = JSON.parse(localStorage.getItem("crm_userdetails"));

      let postOption = {
        organizationid: localStorage.getItem("crm_orgid"),
        userid: localStorage.getItem("crm_userid"),
        username: localStorage.getItem("crm_username"),
        domain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.domain`
        ),
        subdomain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.subdomain`
        ),
        profileid: userDetail.profileid,
        data: {
          metafield: {
            metaobjectid: metaobjectid,
            metaobjectname: metaobjectname,
          },
        },
      };

      console.log("postOption", postOption);

      // this.isLoading = true;
      this.dataService.getMetaFieldsForSelection(postOption).subscribe(
        (res) => {
          console.log(res);
          if (res !== null && res.success == 1) {
            const fields = res.data.metafields;
            console.log(fields);

            // Filter and transform fields before adding them to the fieldList
            fields.forEach((field: any) => {
              field.relatedfieldname = metafieldname;
              if (
                field.fieldtype.toLowerCase() !== "id" &&
                field.visible !== false &&
                ![
                  "deleted",
                  "ownertype",
                  "migrated",
                  "organizationid",
                ].includes(field.fieldname.toLowerCase()) &&
                !(
                  this.objectName.toLowerCase().trim() === "lead" &&
                  field.fieldname.toLowerCase() === "converted"
                )
              ) {
                let strLabel = field.labelname;
                strLabel = strLabel[0].toUpperCase() + strLabel.slice(1);
              }
            });

            // this.isLoading = false;
            resolve(fields || []);
          } else {
            console.log("No fields data!");
            this.isLoading = false;
            resolve(null);
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          resolve(null);
        }
      );
    });
  }

  next() {
    console.log(this.objectSelectComponent);

    this.metaobjectId = this.objectSelectComponent.metaobjectid;
    this.objectName = this.objectSelectComponent.objectname;

    console.log(this.metaobjectId);
    console.log(this.objectName);

    if (this.metaobjectId == "" || this.metaobjectId == undefined) {
      this.showWarning("Select object to proceed");
      return;
    }

    // console.log(this.currentTemplate)
    this.currentTemplate = "create"; // Switch to another template

    this.router.navigateByUrl(
      "home/duplicaterule/create/new/" +
        this.objectName +
        "/" +
        this.metaobjectId
      // "home/matchingrule/create/new"
    );
  }

  // parentObjectChange(event: { value: string; label: any }) {
  //   console.log("parentObjectChange", event);
  //   console.log(this.matchingRuleForm)
  //   if (event.value.trim() != "") {
  //     this.matchingRuleForm.controls["objectid"].setValue(event.value);
  //     this.matchingRuleForm.controls["objectname"].setValue(event.label);

  //     // this.metaobjectid = event.value
  //     this.ruleobjectname = event.label;
  //     this.getActiveMatchingRulesByObject();
  //   } else {
  //     this.matchingRuleForm.controls["objectid"].setValue("");
  //     this.matchingRuleForm.controls["objectname"].setValue("");
  //   }
  // }

  parentObjectChange(event: { value: string; label: any }, index: number) {
    console.log(index);
    const ruleArray = this.matchingRuleForm.get("rules") as FormArray; // Access the form array

    if (ruleArray && ruleArray.length > index) {
      // Ensure the array and index are valid
      const ruleGroup = ruleArray.at(index) as FormGroup; // Access a specific form group
      console.log(ruleGroup); // Log the form group to check its existence

      if (ruleGroup) {
        if (event.value.trim() !== "") {
          ruleGroup.controls["objectid"].setValue(event.value);
          ruleGroup.controls["objectname"].setValue(event.label);
          // this.ruleobjectname = event.label;
          // this.getActiveMatchingRulesByObject();
          this.getActiveMatchingRulesByObject(index); // Pass index if needed to fetch matching rules for that specific object
        } else {
          ruleGroup.controls["objectid"].setValue("");
          ruleGroup.controls["objectname"].setValue("");
        }
      }
    } else {
      console.error("Form group not found at index:", index);
    }
  }

  getActiveObjectsByType() {
    return new Promise((resolve, reject) => {
      console.log("getActiveObjectsByType");

      let postOption = {
        organizationid: localStorage.getItem("crm_orgid"),
        userid: localStorage.getItem("crm_userid"),
        username: localStorage.getItem("crm_username"),
        // domain: localStorage.getItem("domain"),
        // subdomain: localStorage.getItem("subdomain"),
        domain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.domain`
        ),
        subdomain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.subdomain`
        ),
        data: {
          metaobject: {
            objecttype: "Domain",
          },
        },
      };
      console.log("postOption", postOption);
      this.isLoading = true;
      this.dataService.getActiveObjectsByType(postOption).subscribe(
        (res) => {
          console.log(res);
          if (res !== null && res.success == 1) {
            var activeObjects = res.data.metaobjects;
            var objArr = [];
            //just add an empty entry sice this field is optional
            objArr.push({ value: "", label: "--None--" });
            for (let i = 0; i < activeObjects.length; i++) {
              objArr.push({
                value: activeObjects[i].id,
                label: activeObjects[i].name,
              });
            }
            this.parentObjects = objArr;

            // this.isLoading = false;
            resolve(null);
          } else {
            console.log("No metaobject data!");
            this.errorMessage =
              res != null ? res.message : "No metaobject data!";
            this.isError = true;
            this.isLoading = false;
            resolve(null);
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          resolve(null);
        }
      );
    });
  }

  matchingRuleChange(event: { value: string; label: any }, index: number) {
    console.log("matchingRuleChange", event);
    // if (event.value.trim() != "") {
    //   this.matchingRuleForm.controls["matchingruleid"].setValue(event.value);
    //   this.matchingRuleForm.controls["matchingrulename"].setValue(event.label);

    //   // this.metaobjectid = event.value
    //   // this.ruleobjectname = event.label
    // } else {
    //   this.matchingRuleForm.controls["matchingruleid"].setValue("");
    //   this.matchingRuleForm.controls["matchingrulename"].setValue("");
    // }

    console.log(index);
    const ruleArray = this.matchingRuleForm.get("rules") as FormArray; // Access the form array

    if (ruleArray && ruleArray.length > index) {
      // Ensure the array and index are valid
      const ruleGroup = ruleArray.at(index) as FormGroup; // Access a specific form group
      console.log(ruleGroup); // Log the form group to check its existence

      if (ruleGroup) {
        if (event.value.trim() !== "") {
          ruleGroup.controls["matchingruleid"].setValue(event.value);
          ruleGroup.controls["matchingrulename"].setValue(event.label);
        } else {
          ruleGroup.controls["matchingruleid"].setValue("");
          ruleGroup.controls["matchingrulename"].setValue("");
        }
      }
    } else {
      console.error("Form group not found at index:", index);
    }
  }

  // getActiveMatchingRulesByObject() {
  //   return new Promise((resolve, reject) => {
  //     console.log("getActiveObjectsByType");

  //     let postOption = {
  //       organizationid: localStorage.getItem("crm_orgid"),
  //       userid: localStorage.getItem("crm_userid"),
  //       username: localStorage.getItem("crm_username"),
  //       // domain: localStorage.getItem("domain"),
  //       // subdomain: localStorage.getItem("subdomain"),
  //       domain: localStorage.getItem(
  //         `${localStorage.getItem("crm_orgid")}.domain`
  //       ),
  //       subdomain: localStorage.getItem(
  //         `${localStorage.getItem("crm_orgid")}.subdomain`
  //       ),
  //       data: {
  //         matchingrule: {
  //           metaobjectname: this.ruleobjectname,
  //         },
  //       },
  //     };
  //     console.log("postOption", postOption);
  //     // this.isLoading = true;
  //     this.dataService.getActiveMatchingRulesByObject(postOption).subscribe(
  //       (res) => {
  //         console.log(res);
  //         if (res !== null && res.success == 1) {
  //           var activeMatchingRules = res.data.matchingrule;
  //           var matArr = [];
  //           //just add an empty entry sice this field is optional
  //           // objArr.push({ value: "", label: "--None--" });
  //           for (let i = 0; i < activeMatchingRules.length; i++) {
  //             matArr.push({
  //               value: activeMatchingRules[i].id,
  //               label: activeMatchingRules[i].name,
  //             });
  //           }
  //           this.matchingRules = matArr;

  //           // this.isLoading = false;
  //           resolve(null);
  //         } else {
  //           console.log("No matching rule data for these object!");
  //           this.errorMessage =
  //             res != null
  //               ? res.message
  //               : "No matching rule data for these object!";
  //           this.isError = true;
  //           this.isLoading = false;
  //           resolve(null);
  //         }
  //       },
  //       (err) => {
  //         console.log("Error***:", err);
  //         this.errorMessage = err.message;
  //         this.isError = true;
  //         this.isLoading = false;
  //         resolve(null);
  //       }
  //     );
  //   });
  // }

  // Object to store matching rules for each index

  matchingRulesByIndex: { [index: number]: any[] } = {};

  getActiveMatchingRulesByObject(index: any) {
    return new Promise((resolve, reject) => {
      console.log("getActiveMatchingRulesByObject");

      const ruleArray = this.matchingRuleForm.get("rules") as FormArray;

      if (ruleArray && ruleArray.length > index) {
        const ruleGroup = ruleArray.at(index) as FormGroup;
        const objectName = ruleGroup.controls["objectname"].value; // Fetch object name for the specific index

        let postOption = {
          organizationid: localStorage.getItem("crm_orgid"),
          userid: localStorage.getItem("crm_userid"),
          username: localStorage.getItem("crm_username"),
          domain: localStorage.getItem(
            `${localStorage.getItem("crm_orgid")}.domain`
          ),
          subdomain: localStorage.getItem(
            `${localStorage.getItem("crm_orgid")}.subdomain`
          ),
          data: {
            matchingrule: {
              metaobjectname: objectName, // Use the object name for the specific index
            },
          },
        };

        console.log("postOption", postOption);

        // Call the service to fetch matching rules
        this.dataService.getActiveMatchingRulesByObject(postOption).subscribe(
          (res) => {
            console.log(res);
            if (res !== null && res.success === 1) {
              const activeMatchingRules = res.data.matchingrule;
              const matArr = [];

              // Populate matching rules array
              for (let i = 0; i < activeMatchingRules.length; i++) {
                matArr.push({
                  value: activeMatchingRules[i].id,
                  label: activeMatchingRules[i].name,
                });
              }

              // Store matching rules for the specific index
              this.matchingRulesByIndex[index] = matArr;

              resolve(null);
            } else {
              console.log("No matching rule data for this object!");
              this.errorMessage =
                res != null
                  ? res.message
                  : "No matching rule data for this object!";
              this.isError = true;
              this.isLoading = false;
              resolve(null);
            }
          },
          (err) => {
            console.log("Error***:", err);
            this.errorMessage = err.message;
            this.isError = true;
            this.isLoading = false;
            resolve(null);
          }
        );
      } else {
        console.error("Form group not found at index:", index);
        resolve(null);
      }
    });
  }

  getDuplicateRuleById(allfields: any) {
    return new Promise((resolve, reject) => {
      let postOption = {
        organizationid: localStorage.getItem("crm_orgid"),
        userid: localStorage.getItem("crm_userid"),
        username: localStorage.getItem("crm_username"),
        // domain: localStorage.getItem("domain"),
        // subdomain: localStorage.getItem("subdomain"),
        domain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.domain`
        ),
        subdomain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.subdomain`
        ),
        data: {
          duplicaterule: {
            id: this.duplicateRuleId,
          },
        },
      };
      console.log(this.matchingRuleId);
      console.log(postOption);
      // this.isLoading = true;
      this.dataService.getDuplicateRuleById(postOption).subscribe(
        (res) => {
          // alert('****res****' + JSON.stringify(res));
          console.log(res);
          if (res.success == 1) {
            this.duplicateRules = res.data.duplicaterule;
            console.log("Doneeee****", this.duplicateRules);
            console.log("this.duplicateRules.actiononcreate", this.duplicateRules.actiononcreate);
            if (this.duplicateRules != null) {
              this.detailForm.controls["rulename"].setValue(
                this.duplicateRules.name
              );
              this.detailForm.controls["description"].setValue(
                this.duplicateRules.description
              );
              this.detailForm.controls["recordlevelsecurity"].setValue(
                this.duplicateRules.recordlevelsecurity
              );

              this.filterForm.controls["filterlogic"].setValue(
                this.duplicateRules.filterlogic
              );
              this.actionForm.controls["alerttext"].setValue(
                this.duplicateRules.alerttext
              );
              this.actionForm.controls["actiononcreate"].setValue(
                this.duplicateRules.actiononcreate
              );
              this.actionForm.controls["actiononedit"].setValue(
                this.duplicateRules.actiononedit
              );
              this.actionForm.controls["actiononcreatealert"].setValue(
                this.duplicateRules.actiononcreatealert
              );
              this.actionForm.controls["actiononcreatereport"].setValue(
                this.duplicateRules.actiononcreatereport
              );
              this.actionForm.controls["actiononeditalert"].setValue(
                this.duplicateRules.actiononeditalert
              );
              this.actionForm.controls["actiononeditreport"].setValue(
                this.duplicateRules.actiononeditreport
              );
            }

            var criterias = res.data.duplicaterule.duplicaterulecriteria;
            var index = 0;
            if (criterias.length > 0) {
              for (let i = 0; i < criterias.length; i++) {
                for (let i = 0; i < allfields.length; i++) {
                  var field = allfields[i];

                  console.log(field.labelname);

                  //skip id type fields if there
                  if (field.fieldtype.toLowerCase() == "id") continue;

                  //skip fields with visibility false
                  if (field.visible == false) continue;

                  //skip fields deleted, ownertype etc.,
                  if (
                    field.fieldname.toLowerCase() == "deleted" ||
                    field.fieldname.toLowerCase() == "ownertype" ||
                    field.fieldname.toLowerCase() == "migrated" ||
                    field.fieldname.toLowerCase() == "organizationid" ||
                    field.fieldname.toLowerCase() == "search" ||
                    field.fieldname.toLowerCase() == "date_range"
                  )
                    continue;

                  //skip converted field if object is lead
                  if (
                    this.objectName.toLowerCase().trim() == "lead" &&
                    field.fieldname.toLowerCase() == "converted"
                  )
                    continue;

                  //convert to titecase
                  var strLabel = field.labelname;
                  var formattedLabel = field.metaobjectname + ": " + strLabel;

                  strLabel = strLabel[0].toUpperCase() + strLabel.slice(1);
                  // this.fieldList.push({
                  //   value: field.fieldname,
                  //   label: formattedLabel,
                  //   fieldtype: field.fieldtype,
                  //   standard: field.standard,
                  //   options: field.options,
                  //   metaobjectname: field.metaobjectname,

                  //   id: field.id,
                  // });
                  this.fieldList.push({
                    // value: field.fieldname,
                    value: field.id,

                    label: formattedLabel,
                    fieldtype: field.fieldtype,
                    standard: field.standard,
                    options: field.options,
                    metaobjectname: field.metaobjectname,

                    // id: field.id,
                    id: field.fieldname,
                  });
                }

                var criteria = criterias[i];

                console.log("fieldname", criteria.fieldname);
                //skip id type fields if there
                if (criteria.fieldname.toLowerCase() == "deleted") {
                  console.log("deleted found.");
                  continue;
                }
                //skip converted field if object is lead
                if (
                  this.objectName.toLowerCase().trim() == "lead" &&
                  criteria.fieldname.toLowerCase() == "converted"
                ) {
                  console.log("converted found.");
                  continue;
                }

                //get addnl field detail from fields
                var fldName = "";
                var fldLabel = "";
                var fldType = "";
                var fldOptions: string;

                console.log(allfields);

                for (let j = 0; j < allfields.length; j++) {
                  if (allfields[j].id == criteria.fieldid) {
                    console.log(allfields[j]);
                    fldName = allfields[j].fieldname;
                    //convert to titecase
                    fldLabel = allfields[j].labelname;
                    fldLabel = fldLabel[0].toUpperCase() + fldLabel.slice(1);
                    fldType = allfields[j].fieldtype;

                    if (allfields[j].options != null) {
                      fldOptions = allfields[j].options;
                    }
                    //console.log("fldOptions", fldOptions);
                    break;
                  }
                }

                //add item
                console.log("criteria", criteria);
                this.addFilterItem(
                  criteria.fieldid,
                  fldName,
                  fldType,
                  fldOptions,
                  criteria.operator,
                  criteria.fieldvalue,
                  criteria.value,
                  criteria.metaobjectname
                );
                if (fldOptions != null) {
                  var arr = JSON.parse(fldOptions);
                  this.picklistValueList[index] = arr;
                }

                index++;
              }
            } else {
              this.getMetaFieldsForSelection().then((res) => {
                console.log("response1111", res);
                // this.fields = res
                console.log("Field list after processing:", this.fields);

                this.retrieveLookupFields().then((res) => {
                  console.log("response1111", res);
                  // console.log("Field list after processing:", this.allFields);
                  console.log("Field list after processing:", this.fields);

                  // const fieldsForSelection = [...this.fields, ...this.allFields];
                  const fieldsForSelection = [
                    ...this.fields,
                    ...this.allFields,
                  ];

                  // //add default --None-- into field list
                  // this.fieldList.push({
                  //   value: "--None--",
                  //   label: "--None--",
                  //   fieldtype: "text",
                  //   standard: true,
                  //   options: [],
                  //   id: "",
                  // });

                  // Check if "--None--" is already present in the list
                  // if (
                  //   !this.fieldList.some((item) => item.value === "--None--")
                  // ) {
                  //   this.fieldList.push({
                  //     value: "",
                  //     label: "--None--",
                  //     fieldtype: "text",
                  //     standard: true,
                  //     options: [],
                  //     id: "",
                  //   });
                  // }

                  console.log(fieldsForSelection);

                  //create fieldlist from fields as readable form by selection control
                  for (let i = 0; i < fieldsForSelection.length; i++) {
                    var field = fieldsForSelection[i];

                    console.log(field.labelname);

                    //skip id type fields if there
                    if (field.fieldtype.toLowerCase() == "id") continue;

                    //skip fields with visibility false
                    if (field.visible == false) continue;

                    //skip fields deleted, ownertype etc.,
                    if (
                      field.fieldname.toLowerCase() == "deleted" ||
                      field.fieldname.toLowerCase() == "ownertype" ||
                      field.fieldname.toLowerCase() == "migrated" ||
                      field.fieldname.toLowerCase() == "organizationid" ||
                      field.fieldname.toLowerCase() == "search" ||
                      field.fieldname.toLowerCase() == "date_range"
                    )
                      continue;

                    //skip converted field if object is lead
                    if (
                      this.objectName.toLowerCase().trim() == "lead" &&
                      field.fieldname.toLowerCase() == "converted"
                    )
                      continue;

                    //convert to titecase
                    var strLabel = field.labelname;
                    var formattedLabel = field.metaobjectname + ": " + strLabel;

                    strLabel = strLabel[0].toUpperCase() + strLabel.slice(1);
                    this.fieldList.push({
                      // value: field.fieldname,
                      value: field.id,

                      label: formattedLabel,
                      fieldtype: field.fieldtype,
                      standard: field.standard,
                      options: field.options,
                      metaobjectname: field.metaobjectname,

                      // id: field.id,
                      id: field.fieldname,
                    });
                  }

                  //load default done list first
                  // this.loadDefaultDoneList();

                  this.addFilterItem("", "", "", [], "", "", "", "");
                  this.addFilterItem("", "", "", [], "", "", "", "");
                  this.addFilterItem("", "", "", [], "", "", "", "");

                  // this.isDataLoaded = true;
                });
                this.isLoading = false;
                this.isDataLoaded = true;
              });
            }

            this.populateRules(res);

            // var dupmatchingrule = res.data.duplicaterule.duplicatematchingrule;
            // var index2 = 0;

            // const rulesArray = this.matchingRuleForm.get("rules") as FormArray;

            // // Clear any existing rules to avoid duplicates
            // while (rulesArray.length !== 0) {
            //   rulesArray.removeAt(0);
            // }
            // // Loop through the dupmatchingrule array and populate form controls
            // for (let i = 0; i < dupmatchingrule.length; i++) {
            //   const rule = dupmatchingrule[i];

            //   // Create a new rule form group and populate it with values from dupmatchingrule
            //   const ruleGroup = this.createRule(); // Assumes you have a createRule() method that returns a FormGroup

            //   console.log(rule);
            //   ruleGroup.patchValue({
            //     object: rule.matchwithobjectid,
            //     matchingrule: rule.matchingruleid,
            //     objectid: rule.matchwithobjectid,
            //     objectname: rule.matchwithobjectname,
            //     matchingruleid: rule.matchingruleid,
            //     matchingrulename: rule.matchingrulename,

            //     // Add other fields here
            //   });

            //   // this.getActiveMatchingRulesByObject();
            //   let postOption = {
            //     organizationid: localStorage.getItem("crm_orgid"),
            //     userid: localStorage.getItem("crm_userid"),
            //     username: localStorage.getItem("crm_username"),
            //     // domain: localStorage.getItem("domain"),
            //     // subdomain: localStorage.getItem("subdomain"),
            //     domain: localStorage.getItem(
            //       `${localStorage.getItem("crm_orgid")}.domain`
            //     ),
            //     subdomain: localStorage.getItem(
            //       `${localStorage.getItem("crm_orgid")}.subdomain`
            //     ),
            //     data: {
            //       matchingrule: {
            //         metaobjectname: rule.matchwithobjectname,
            //       },
            //     },
            //   };
            //   console.log("postOption", postOption);
            //   // this.isLoading = true;

            //   this.dataService
            //     .getActiveMatchingRulesByObject(postOption)
            //     .subscribe(
            //       (res) => {
            //         console.log(res);
            //         if (res !== null && res.success == 1) {
            //           var activeMatchingRules = res.data.matchingrule;
            //           const matArr = [];
            //           //just add an empty entry sice this field is optional
            //           // objArr.push({ value: "", label: "--None--" });
            //           for (let i = 0; i < activeMatchingRules.length; i++) {
            //             matArr.push({
            //               value: activeMatchingRules[i].id,
            //               label: activeMatchingRules[i].name,
            //             });
            //           }
            //           // this.matchingRules = matArr;
            //           this.matchingRulesByIndex[index] = matArr;
            //           rulesArray.push(ruleGroup);

            //           this.isLoading = false;
            //           this.isDataLoaded = true;

            //           resolve(null);
            //         } else {
            //           console.log("No matching rule data for these object!");
            //           this.errorMessage =
            //             res != null
            //               ? res.message
            //               : "No matching rule data for these object!";
            //           this.isError = true;
            //           this.isLoading = false;
            //           resolve(null);
            //         }
            //       },
            //       (err) => {
            //         console.log("Error***:", err);
            //         this.errorMessage = err.message;
            //         this.isError = true;
            //         this.isLoading = false;
            //         resolve(null);
            //       }
            //     );

            //   // Add the populated rule form group to the rules array
            //   rulesArray.push(ruleGroup);
            // }

            // this.isLoading = false;
          } else {
            console.log("no data");
            this.isLoading = false;
            //this.resetDetailFormControls();
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          //this.resetDetailFormControls();
        }
      );
    });
  }

  async populateRules(res: any) {
    var dupmatchingrule = res.data.duplicaterule.duplicatematchingrule;
    const rulesArray = this.matchingRuleForm.get("rules") as FormArray;

    // Clear any existing rules to avoid duplicates
    while (rulesArray.length !== 0) {
      rulesArray.removeAt(0);
    }

    // Loop through the dupmatchingrule array and populate form controls
    for (let i = 0; i < dupmatchingrule.length; i++) {
      const rule = dupmatchingrule[i];

      // Create a new rule form group and populate it with values from dupmatchingrule
      const ruleGroup = this.createRule(); // Assumes you have a createRule() method that returns a FormGroup

      console.log(rule);
      ruleGroup.patchValue({
        object: rule.matchwithobjectid,
        matchingrule: rule.matchingruleid,
        objectid: rule.matchwithobjectid,
        objectname: rule.matchwithobjectname,
        matchingruleid: rule.matchingruleid,
        matchingrulename: rule.matchingrulename,

        // Add other fields here
      });

      // Prepare the postOption
      let postOption = {
        organizationid: localStorage.getItem("crm_orgid"),
        userid: localStorage.getItem("crm_userid"),
        username: localStorage.getItem("crm_username"),
        domain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.domain`
        ),
        subdomain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.subdomain`
        ),
        data: {
          matchingrule: {
            metaobjectname: rule.matchwithobjectname,
          },
        },
      };

      console.log("postOption", postOption);

      try {
        // Await the API response for the current rule
        const res = await this.dataService
          .getActiveMatchingRulesByObject(postOption)
          .toPromise();

        if (res !== null && res.success == 1) {
          const activeMatchingRules = res.data.matchingrule;
          const matArr = [];
          // Prepare matching rules array for the current rule
          for (let i = 0; i < activeMatchingRules.length; i++) {
            matArr.push({
              value: activeMatchingRules[i].id,
              label: activeMatchingRules[i].name,
            });
          }
          // Store matching rules for the specific index
          this.matchingRulesByIndex[i] = matArr; // Using 'i' as the index

          // Add the populated rule form group to the rules array
          rulesArray.push(ruleGroup);
        } else {
          console.log("No matching rule data for this object!");
          this.errorMessage =
            res != null
              ? res.message
              : "No matching rule data for this object!";
          this.isError = true;
        }
      } catch (err) {
        console.log("Error***:", err);
        this.errorMessage = err.message;
        this.isError = true;
      }
    }

    this.isLoading = false;
    this.isDataLoaded = true;
  }

  save() {
    if (this.detailForm.controls["rulename"].value.toString().trim() == "") {
      this.showWarning("Name is mandatory");
      return;
    }

    console.log("mode", this.mode);
    if (this.mode.toLowerCase() == "new") {
      this.duplicateRuleId = this.guid.getGUID("duplicaterule");
    }

    //prepare data for saving: application
    let postOption = {
      organizationid: localStorage.getItem("crm_orgid"),
      domain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.domain`
      ),
      subdomain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.subdomain`
      ),
      userid: localStorage.getItem("crm_userid"),
      username: localStorage.getItem("crm_username"),
      useralias: localStorage.getItem("crm_useralias"),
      // profileid: userDetail.profileid,
      // profilename: userDetail.profilename,
      data: {
        duplicaterule: {
          id: this.duplicateRuleId,
          metaobjectid: this.metaobjectId,
          metaobjectname: this.objectName,
          mode: this.mode,
          name: this.detailForm.controls["rulename"].value.trim(),
          recordlevelsecurity:
            this.detailForm.controls["recordlevelsecurity"].value.trim(),
          description: this.detailForm.controls["description"].value.trim(),
          actiononcreate:
            this.actionForm.controls["actiononcreate"].value.trim(),
          actiononedit: this.actionForm.controls["actiononedit"].value.trim(),
          actiononcreatealert:
            this.actionForm.controls["actiononcreatealert"].value,
          actiononcreatereport:
            this.actionForm.controls["actiononcreatereport"].value,
          actiononeditalert:
            this.actionForm.controls["actiononeditalert"].value,
          actiononeditreport:
            this.actionForm.controls["actiononeditreport"].value,
          alerttext: this.actionForm.controls["alerttext"].value,
          filterlogic: this.filterForm.controls["filterlogic"].value,
          duplicaterulecriteria: [],
          duplicatematchingrule: [],
          duplicaterulejsontext: {},

          // active: this.detailForm.controls["active"].value,
          // filterlogic: this.filterForm.controls["filterlogic"].value,
          // matchingrulecriteria: [],
        },
      },
    };

    var arrRules = [];

    var arrayRuleControl = this.matchingRuleForm.get("rules") as FormArray;

    for (let c of arrayRuleControl.controls) {
      console.log(c);
      var objectId = c.get("objectid").value;
      var objectName = c.get("objectname").value;
      var matchRuleId = c.get("matchingruleid").value;
      var matchRuleName = c.get("matchingrulename").value;

      if (
        objectId != "" ||
        objectId != undefined ||
        matchRuleId != "" ||
        matchRuleId != undefined
      ) {
        var matchRule = {
          id: this.guid.getGUID("duplicatematchingrule"),
          duplicateruleid: this.duplicateRuleId,
          metaobjectid: this.metaobjectId,
          metaobjectname: this.objectName,
          matchwithobjectid: objectId,
          matchwithobjectname: objectName,
          matchingruleid: matchRuleId,
          matchingrulename: matchRuleName,
        };

        //push it to array
        arrRules.push(matchRule);
      }
    }
    postOption.data.duplicaterule.duplicatematchingrule = arrRules;

    var arrfilters = [];

    var arrayControl = this.filterForm.get("filteritems") as FormArray;

    for (let c of arrayControl.controls) {
      console.log(c);
      var fieldId = c.get("fieldid").value;
      var fieldName = c.get("fieldname").value;
      var fieldType = c.get("fieldtype").value;
      var value = c.get("fieldvalue").value;
      var fieldOperator = c.get("operator").value;
      var metaObjName = c.get("metaobjectname").value;

      if (
        fieldOperator.toLowerCase().trim() == "--none--" ||
        fieldOperator.toLowerCase().trim() == ""
      )
        fieldOperator = "";

      // var value = c.get("fieldvalue").value;
      // if (value.toLowerCase().trim() == "--none--") value = "";
      // if (value == "--none--") value = "";

      if (fieldId != "" && fieldOperator != "") {
        var lookupFilter = {
          id: this.guid.getGUID("duplicaterulecriteria"),
          duplicateruleid: this.duplicateRuleId,

          metaobjectid: this.metaobjectId,
          metaobjectname: this.objectName,
          matchingruleid: this.matchingRuleId,
          // fieldid: fieldId,
          // fieldname: fieldName,
          fieldid: fieldName,
          fieldname: fieldId,
          fieldtype: fieldType,
          operator: fieldOperator,
          fieldvalue: value,
          criteriaobjectname: metaObjName,
        };

        //push it to array
        arrfilters.push(lookupFilter);
      }
    }

    var duplicateRuleJson = {
      id: this.guid.getGUID("duplicaterule"),
      metaobjectid: this.metaobjectId,
      metaobjectname: this.objectName,
      duplicateruleid: this.duplicateRuleId,
      jsontext: {},
    };

    postOption.data.duplicaterule.duplicaterulejsontext = duplicateRuleJson;

    postOption.data.duplicaterule.duplicaterulecriteria = arrfilters;

    console.log(postOption);
    this.isLoading = true;
    this.dataService.upsertDuplicateRule(postOption).subscribe(
      (res) => {
        //alert('****res****' + JSON.stringify(res));
        console.log(res);
        if (res.success == 1) {
          this.showSuccess(res.message);
          this.isLoading = false;
          this.router.navigateByUrl("home/duplicaterulelist");
        } else {
          console.log("error while saving");
          this.showError(res.message);
          this.isLoading = false;
        }
      },
      (err) => {
        console.log("Error***:", err);
        this.showError(err.message);
        this.isError = true;
        this.isLoading = false;
      }
    );
  }
  previous() {
    this.router.navigateByUrl(
      "home/duplicaterule/objectSelect/new"
      // "home/matchingrule/create/new"
    );
  }

  cancel() {
    this.router.navigateByUrl("home/duplicaterulelist");
  }
}
